// extracted by mini-css-extract-plugin
module.exports = {"card":"committee-card_card__2Dkdl","box":"committee-card_box__1y1pR","content":"committee-card_content__2w-GA"};